import { render } from "./TrailerDiagram.vue?vue&type=template&id=68a75f86&scoped=true"
import script from "./TrailerDiagram.vue?vue&type=script&lang=js"
export * from "./TrailerDiagram.vue?vue&type=script&lang=js"

import "./TrailerDiagram.vue?vue&type=style&index=0&id=68a75f86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a75f86"]])

export default __exports__